export const GET_LIST_QUIZ_ATTEMPTS = '/quiz-attempt/list';
